module.exports = __webpack_public_path__ + "static/media/overflow-menu.c2e3a424.svg";